/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22.7393C17.5228 22.7393 22 18.2621 22 12.7393C22 7.21641 17.5228 2.73926 12 2.73926C6.47715 2.73926 2 7.21641 2 12.7393C2 18.2621 6.47715 22.7393 12 22.7393Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 13.7393C13.6569 13.7393 15 12.3961 15 10.7393C15 9.0824 13.6569 7.73926 12 7.73926C10.3431 7.73926 9 9.0824 9 10.7393C9 12.3961 10.3431 13.7393 12 13.7393Z"
      fill="#262626"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7 21.4013V19.7393C7 19.2088 7.21071 18.7001 7.58579 18.325C7.96086 17.95 8.46957 17.7393 9 17.7393H15C15.5304 17.7393 16.0391 17.95 16.4142 18.325C16.7893 18.7001 17 19.2088 17 19.7393V21.4013"
      fill="#262626"
    />
    <path
      d="M7 21.4013V19.7393C7 19.2088 7.21071 18.7001 7.58579 18.325C7.96086 17.95 8.46957 17.7393 9 17.7393H15C15.5304 17.7393 16.0391 17.95 16.4142 18.325C16.7893 18.7001 17 19.2088 17 19.7393V21.4013L14.5 22.0703H9.5L7 21.4013Z"
      stroke="#262626"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgComponent;
